import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { utils, writeFile } from "xlsx";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { CiPlay1 } from "react-icons/ci";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import DateRangePicker from "react-bootstrap-daterangepicker";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import { Card, Col, Row, Space, Statistic, Typography } from "antd";
import { IoAlertCircle, IoCall, IoCallOutline } from "react-icons/io5";
import "./agentCallLogsAndRecordings.css";
import { useDispatch, useSelector } from "react-redux";
import api from "../../../core/axios/axiosInstance";
import { useDebounce } from "../../../core/hooks/useDebounce";
import { fetchCallHistoryAgent } from "../../../core/data/redux/slices/CallHistoryAgentSlice";
import {
  resolveCallFromNumber,
  resolveCallToNumber,
} from "../../../core/utils/callNumberResolver";

const AgentCallLogsAndRecordings = () => {
  const { Title, Text } = Typography;

  dayjs.extend(utc);
  dayjs.extend(timezone);

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const last7Start = new Date(today);
  last7Start.setDate(today.getDate() - 7);

  const last30Start = new Date(today);
  last30Start.setDate(today.getDate() - 30);

  const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const thisMonthEnd = new Date(
    now.getFullYear(),
    now.getMonth() + 1,
    0,
    23,
    59,
    59,
    999
  );

  const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const lastMonthEnd = new Date(
    now.getFullYear(),
    now.getMonth(),
    0,
    23,
    59,
    59,
    999
  );

  useEffect(() => {
    const modalEl = document.getElementById("play_recording");

    if (!modalEl) return;

    const handleClose = () => {
      setAudioUrl(null);
    };

    modalEl.addEventListener("hidden.bs.modal", handleClose);

    return () => {
      modalEl.removeEventListener("hidden.bs.modal", handleClose);
    };
  }, []);

  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCallStatus, setSelectedCallStatus] = useState([]);
  const [selectedCallDirection, setSelectedCallDirection] = useState([]);
  const [activeRowKey, setActiveRowKey] = useState(null);
  const [stars, setStars] = useState({});
  const callHistoryState = useSelector((state) => state.callHistoryAgent) || {};
  const [audioUrl, setAudioUrl] = useState(null);
  const [startDate, setStartDate] = useState(
    new Date(
      last7Start.getFullYear(),
      last7Start.getMonth(),
      last7Start.getDate(),
      0,
      0,
      0,
      0
    ).toISOString()
  );
  const [endDate, setEndDate] = useState(
    new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      23,
      59,
      59,
      999
    ).toISOString()
  );
  const debouncedSearch = useDebounce(searchQuery);
  const callLogs = callHistoryState.data;
  const callLogsSummary = callHistoryState.summary;
  const callHistoryGlobalState =
    useSelector((state) => state.callHistory) || {};

  const [isRefreshing, setIsRefreshing] = useState(false);

  const [columnVisibility, setColumnVisibility] = useState({
    // "": true,
    // "Call Id": true,
    "Call Type": true,
    "Call Date": true,
    "Extension": true,
    "Call Duration": true,
    "Customer Number": true,
    Direction: true,
    "Call Status": true,
    "Next FollowUp": true,
    Recording: true,
  });

  useEffect(() => {
    const payload = {
      page: 1,
      page_size: 10,
      search: debouncedSearch,
      status: selectedCallStatus,
      callType: selectedCallDirection,
      startDate,
      endDate,
    };

    dispatch(fetchCallHistoryAgent(payload));
  }, [
    debouncedSearch,
    selectedCallStatus,
    startDate,
    endDate,
    selectedCallDirection,
  ]);

  useEffect(() => {
    if (!callLogs?.length) return;
    const billed = callLogs.filter((c) => c.charges != null);
    console.log(`[BILLING-UI] Call records loaded — total: ${callLogs.length} | billed calls: ${billed.length}`);
    billed.forEach((c) => {
      const resolvedFrom = resolveCallFromNumber(c) || c.call_from || "N/A";
      const resolvedTo = resolveCallToNumber(c) || c.call_to || "N/A";
      if (resolvedFrom !== c.call_from) {
        console.log("[BILLING-UI] call_from resolved from alternate API fields", {
          call_from: c.call_from,
          from_number: c.from_number,
          caller_number: c.caller_number,
          source_number: c.source_number,
          src: c.src,
          resolvedFrom,
        });
      }
      console.log(
        `[BILLING-UI] ✓ Billed call — from: ${resolvedFrom} | to: ${resolvedTo} | direction: ${c.direction} | status: ${c.status} | talk_time: ${c.talk_time}s | rate: $${c.ratePerMin}/min | charges: $${c.charges} | DID: ${c.billedFrom}`
      );
    });
    if (billed.length === 0) {
      console.log(`[BILLING-UI] — No billed calls in this page (either no purchased DID calls or no matching rate)`);
    }
  }, [callLogs]);

  useEffect(() => {
    if (audioUrl) {
      const audio = document.getElementById("globalAudioPlayer");
      if (audio) audio.play();
    }
  }, [audioUrl]);

  const formatCallDate = (value) => {
    if (!value) return "";
    // const dubaiTime = dayjs.tz(value, "Asia/Dubai");
    // return dubaiTime.tz(dayjs.tz.guess()).format("DD MMM YYYY, h:mma");
     return dayjs(value).format("DD MMM YYYY, h:mma");
  };

  const formatCallDuration = (value) => {
    if (!value) return "";

    const totalSeconds = Number(value);
    if (isNaN(totalSeconds)) return "";

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return hours > 0
      ? `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
          .toString()
          .padStart(2, "0")}`
      : `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  // useEffect(() => {

  //   const fetchAgents = async () => {
  //     const response = await api.get("/admin/user/getAgent")
  //     setAgents(response.data.data)

  //   }

  //   fetchAgents()
  // }, [])

  const initialSettings = {
    // endDate: now,

    ranges: {
      "Last 30 Days": [last30Start, now],
      "Last 7 Days": [last7Start, now],
      "Last Month": [lastMonthStart, lastMonthEnd],
      "This Month": [thisMonthStart, thisMonthEnd],
      Today: [today, today],
      Yesterday: [yesterday, yesterday],
    },

    startDate: dayjs(last7Start).toDate(), // JS Date
    endDate: dayjs(today).toDate(), // JS Date
    timePicker: false,
  };
  const callStatus = [
    { value: "noAnswered", label: "Not Answered" },
    { value: "answered", label: "Answered" },
    { value: "missedCall", label: "Missed" },
    { value: "cancelled", label: "Cancelled" },
    { value: "invalid", label: "Invalid" },
  ];
  const callDirection = [
    { value: "inbound", label: "Inbound" },
    { value: "outbound", label: "Outbound" },
  ];

  const currentDateAndTime = new Date();
  const currentDate = currentDateAndTime.toLocaleDateString();
  const currentTime = currentDateAndTime.toLocaleTimeString();

  const filterCallStatus = (callStatus) => {
    setSelectedCallStatus((prevStatus) =>
      prevStatus.includes(callStatus)
        ? prevStatus.filter((status) => status !== callStatus)
        : [...prevStatus, callStatus]
    );
  };
  const filterCallDirection = (callDirection) => {
    setSelectedCallDirection((prevDirection) =>
      prevDirection.includes(callDirection)
        ? prevDirection.filter((direction) => direction !== callDirection)
        : [...prevDirection, callDirection]
    );
  };
  const resetFilters = () => {
    setSelectedCallStatus([]);
    setSelectedCallDirection([]);
  };
  const handleToggleColumnVisibility = (columnTitle) => {
    setColumnVisibility((prevVisibility) => ({
      ...prevVisibility,
      [columnTitle]: !prevVisibility[columnTitle],
    }));
  };

  const handlePlayRecording = async (fileName, rowKey) => {
    try {
      const response = await api.post("/call/recording", {
        record_file: fileName,
      });
      if (response.data?.fileUrl) {
        setAudioUrl(response.data.fileUrl);
        setActiveRowKey(rowKey); // mark this row as active
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      // First, fetch and store new data from Yeastar
      await api.post("call/fetch-and-store");

      // Then, refresh the call history with the updated data
      const payload = {
        page: 1,
        page_size: 10,
        search: debouncedSearch,
        status: selectedCallStatus,
        callType: selectedCallDirection,
        startDate,
        endDate,
      };
      await dispatch(fetchCallHistoryAgent(payload));
    } catch (error) {
      console.error("Error refreshing call history:", error);
    } finally {
      setIsRefreshing(false);
    }
  };
  const columns = [
    {
      title: "Call Date",
      dataIndex: "start_time",
      key: "start_time",
      render: (text, record, index) => {

        return <div>{formatCallDate(text)}</div>;
      },

      sorter: (a, b) => a.start_time.localeCompare(b.start_time),
    },
    {
      title: "Extension",
      dataIndex: "extensionNumber",
      key: "extensionNumber",
      render: (_, record) => {
        const ext = record.extensionNumber;
        const phone = record.extensionPhone;
        if (!ext) return <span style={{ color: "#9ca3af" }}>—</span>;
        return (
          <div style={{ fontWeight: 600, fontSize: 13, color: "#111827", whiteSpace: "nowrap" }}>
            Ext {ext}{phone && <span style={{ fontWeight: 400, color: "#6b7280" }}> ({phone})</span>}
          </div>
        );
      },
    },
    {
      title: "Customer Number",
      dataIndex: "call_to",
      key: "call_to",
      render: (text, record) => {
        // If the UI filter includes inbound calls, show the caller number (`call_from`)
        // Otherwise show the destination number (`call_to`). Fall back safely.
        const isFilteringInbound =
          Array.isArray(selectedCallDirection) &&
          selectedCallDirection.includes("inbound");
        const inboundNumber = resolveCallFromNumber(record);
        const outboundNumber = resolveCallToNumber(record);
        const number = isFilteringInbound
          ? inboundNumber || record.call_from || "N/A"
          : outboundNumber || record.call_to || "N/A";
        return <div>{number || "-"}</div>;
      },
    },
    {
      title: "Call Duration",
      dataIndex: "talk_time",
      key: "talk_time",
      render: (text, record, index) => {
        if (!text) return <div>-</div>;

        return <div>{formatCallDuration(text)}</div>;
      },
      sorter: (a, b) => Number(a.talk_time || 0) - Number(b.talk_time || 0),
    },

    {
      title: "Direction",
      dataIndex: "direction",
      key: "direction",
      sorter: (a, b) => a.direction.localeCompare(b.direction),
    },
    {
      title: "Call Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
    },
    {
      title: "Charges",
      dataIndex: "charges",
      key: "charges",
      align: "right",
      render: (value) => {
        if (value == null) return <div style={{ textAlign: "right", color: "#bfbfbf" }}>—</div>;
        return (
          <div style={{ textAlign: "right", fontWeight: 600, color: "#3C2371" }}>
            ${Number(value).toFixed(4)}
          </div>
        );
      },
    },
    {
      title: "Recording",
      dataIndex: "record_file",
      key: "record_file",
      render: (text, record) => {
        if (!text) return <div className="text-center">-</div>;

        return (
          <div className="d-flex flex-column align-items-center">
            <div className="d-flex justify-content-center align-items-center">
              <span style={{ color: "#00918E" }} className="me-3">
                <FaCloudDownloadAlt />
              </span>
              {/* <span
                style={{ color: "blue", cursor: "pointer" }}
                onClick={() => handlePlayRecording(text, record.key)}

              >
                <CiPlay1 />
              </span> */}
              <span
                style={{ color: "blue", cursor: "pointer" }}
                data-bs-toggle="modal"
                data-bs-target="#play_recording"
                onClick={() => handlePlayRecording(text, record.key)}
              >
                <CiPlay1 />
              </span>
            </div>
          </div>
        );
      },
    },
  ];

  const exportPDF = () => {
    const doc = new jsPDF();

    const filteredColumns = columns.filter(
      (col) => columnVisibility[col.title] && col.title !== "Recording"
    );

    const headers = filteredColumns.map((col) => col.title);
    const data = filteredCallData.map((row) =>
      filteredColumns.map((col) => {
        const value = row[col.dataIndex];
        if (col.dataIndex === "start_time") return formatCallDate(value);
        if (col.dataIndex === "talk_time") return formatCallDuration(value);

        return value || "";
      })
    );

    const pageWidth = doc.internal.pageSize.getWidth();
    const titleText = "Calls Report";
    const titleWidth = doc.getTextWidth(titleText);
    const titleX = (pageWidth - titleWidth) / 2;

    doc.setFontSize(15);
    doc.text(titleText, titleX, 20);

    doc.setFontSize(10);
    doc.text(`Exported on: ${currentDate} at ${currentTime}`, 15, 35);

    autoTable(doc, {
      startY: 40,
      head: [headers],
      body: data,
    });

    doc.save("Call-details.pdf");
  };
  const exportExcel = () => {
    const wb = utils.book_new();

    const filteredColumns = columns.filter(
      (col) => columnVisibility[col.title] && col.title !== "Recording"
    );

    const wsData = [
      filteredColumns.map((col) => col.title),
      ...filteredCallData.map((row) =>
        filteredColumns.map((col) => {
          const value = row[col.dataIndex];

          if (col.dataIndex === "start_time") return formatCallDate(value);
          if (col.dataIndex === "talk_time") return formatCallDuration(value);

          return value || "";
        })
      ),
    ];

    const ws = utils.aoa_to_sheet(wsData);

    utils.book_append_sheet(wb, ws, "Calls");

    writeFile(wb, "calls_report.xlsx");
  };
  const filteredCallData = callLogs?.filter((calls) => {
    return calls;
  });
  const visibleColumns = columns.filter(
    (column) => columnVisibility[column.title]
  );

  const handlePageChange = (page, pageSize) => {
    dispatch(
      fetchCallHistoryAgent({
        page,
        page_size: pageSize,
        search: debouncedSearch,
        status: selectedCallStatus,
        callType: selectedCallDirection,
        startDate,
        endDate,
      })
    );
  };
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="card">
          <div className="card-header">
            {/* Desktop Layout - Single Row */}
            <div className="contacts-header-desktop">
              <div className="contacts-header-left-group">
                <div className="page-header mb-0">
                  <h4 className="page-title mb-0">
                    Filtered Records
                    <span className="count-title">
                      {callHistoryState?.pagination?.total}
                    </span>
                  </h4>
                </div>
              </div>

              <div className="contacts-header-right-group">
                <div className="icon-form contacts-search-desktop">
                  <span className="form-icon">
                    <i className="ti ti-search" />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Phone Number"
                    onChange={(text) => setSearchQuery(text.target.value)}
                  />
                </div>

                <button
                  className="btn btn-primary d-flex align-items-center contacts-refresh-btn"
                  onClick={handleRefresh}
                  disabled={isRefreshing}
                >
                  <i
                    className={`ti ti-refresh fs-5 ${
                      isRefreshing ? "ti-spin" : ""
                    }`}
                  />
                </button>

                <div
                  className="icon-form"
                  style={{
                    width: "230px",
                  }}
                >
                  <span className="form-icon">
                    <i className="ti ti-calendar" />
                  </span>
                  <DateRangePicker
                    initialSettings={initialSettings}
                    onCallback={(start, end) => {
                      const startDate = new Date(
                        start.year(),
                        start.month(),
                        start.date(),
                        0,
                        0,
                        0,
                        0
                      ).toISOString();

                      const endDate = new Date(
                        end.year(),
                        end.month(),
                        end.date(),
                        23,
                        59,
                        59,
                        999
                      ).toISOString();
                      setEndDate(endDate);
                      setStartDate(startDate);
                    }}
                  >
                    <input className="form-control bookingrange" type="text" />
                  </DateRangePicker>
                </div>

                <div className="form-sorts dropdown">
                  <Link
                    to="#"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter-share" />
                    Filter
                  </Link>
                  <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                    <div className="filter-set-view">
                      <div className="filter-set-head">
                        <h4>
                          <i className="ti ti-filter-share" />
                          Filter
                        </h4>
                      </div>
                      <div className="accordion" id="accordionExample">
                        <div className="filter-set-content">
                          <div className="filter-set-content-head">
                            <Link
                              to="#"
                              className="collapsed"
                              data-bs-toggle="collapse"
                              data-bs-target="#Status"
                              aria-expanded="false"
                              aria-controls="Status"
                            >
                              Call Status
                            </Link>
                          </div>
                          <div
                            className="filter-set-contents accordion-collapse collapse"
                            id="Status"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="filter-content-list">
                              <ul>
                                {callStatus.map((callStatus, index) => {
                                  return (
                                    <li key={index}>
                                      <div className="filter-checks">
                                        <label className="checkboxs">
                                          <input
                                            type="checkbox"
                                            checked={selectedCallStatus.includes(
                                              callStatus.value
                                            )}
                                            onChange={() => {
                                              filterCallStatus(
                                                callStatus.value
                                              );
                                            }}
                                          />
                                          <span className="checkmarks" />
                                          {callStatus.label}
                                        </label>
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="filter-set-content">
                          <div className="filter-set-content-head">
                            <Link
                              to="#"
                              className="collapsed"
                              data-bs-toggle="collapse"
                              data-bs-target="#Direction"
                              aria-expanded="false"
                              aria-controls="Direction"
                            >
                              Call Direction
                            </Link>
                          </div>
                          <div
                            className="filter-set-contents accordion-collapse collapse"
                            id="Direction"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="filter-content-list">
                              <ul>
                                {callDirection.map((callDirection, index) => {
                                  return (
                                    <li key={index}>
                                      <div className="filter-checks">
                                        <label className="checkboxs">
                                          <input
                                            type="checkbox"
                                            checked={selectedCallDirection.includes(
                                              callDirection.value.toLowerCase()
                                            )}
                                            onChange={() => {
                                              filterCallDirection(
                                                callDirection.value.toLowerCase()
                                              );
                                            }}
                                          />
                                          <span className="checkmarks" />
                                          {callDirection.label}
                                        </label>
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="filter-reset-btns">
                        <div className="row">
                          <div className="col-6"></div>
                          <div className="col-6">
                            <Link
                              to="#"
                              className="btn btn-primary"
                              onClick={resetFilters}
                            >
                              Reset
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="dropdown">
                  <Link
                    to="#"
                    className="btn bg-soft-purple text-purple"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-columns-3 me-2" />
                    Manage Columns
                  </Link>
                  <div className="dropdown-menu dropdown-menu-md-end dropdown-md p-3">
                    <h4 className="mb-2 fw-semibold">
                      Want to manage datatables?
                    </h4>
                    <p className="mb-3">
                      Please drag and drop your column to reorder your table and
                      enable see option as you want.
                    </p>
                    <div className="border-top pt-3">
                      {columns.map((column, index) => {
                        if (column.title === "Action" || column.title === "") {
                          return;
                        }
                        return (
                          <div
                            className="d-flex align-items-center justify-content-between mb-3"
                            key={index}
                          >
                            <p className="mb-0 d-flex align-items-center">
                              <i className="ti ti-grip-vertical me-2" />
                              {column.title}
                            </p>
                            <div className="status-toggle">
                              <input
                                type="checkbox"
                                id={column.title}
                                className="check"
                                defaultChecked={true}
                                onClick={() =>
                                  handleToggleColumnVisibility(column.title)
                                }
                              />
                              <label
                                htmlFor={column.title}
                                className="checktoggle"
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-package-export me-2" />
                    Export
                  </Link>
                  <div className="dropdown-menu dropdown-menu-end">
                    <ul className="mb-0">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={exportPDF}
                        >
                          <i className="ti ti-file-type-pdf text-danger me-1" />
                          Export as PDF
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={exportExcel}
                        >
                          <i className="ti ti-file-type-xls text-green me-1" />
                          Export as Excel{" "}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile Layout - Keep Current Implementation */}
            <div className="contacts-header-mobile">
              <div className="row align-items-center">
                <div className="col-sm-12">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="page-header mb-0">
                      <h4 className="page-title mb-0 mt-1">
                        Filtered Records
                        <span className="count-title">
                          {callHistoryState?.pagination?.total}
                        </span>
                      </h4>
                    </div>
                  </div>

                  <div className="contacts-header-search-row mb-3">
                    <div className="icon-form flex-grow-1">
                      <span className="form-icon">
                        <i className="ti ti-search" />
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by Phone Number"
                        onChange={(text) => setSearchQuery(text.target.value)}
                      />
                    </div>
                  </div>
                  <div
                    className="icon-form me-2 w-100 mb-4"
                    style={{
                      width: "230px",
                    }}
                  >
                    <span className="form-icon">
                      <i className="ti ti-calendar" />
                    </span>
                    <DateRangePicker
                      initialSettings={initialSettings}
                      onCallback={(start, end) => {
                        const startDate = new Date(
                          start.year(),
                          start.month(),
                          start.date(),
                          0,
                          0,
                          0,
                          0
                        ).toISOString();

                        const endDate = new Date(
                          end.year(),
                          end.month(),
                          end.date(),
                          23,
                          59,
                          59,
                          999
                        ).toISOString();
                        setEndDate(endDate);
                        setStartDate(startDate);
                      }}
                    >
                      <input
                        className="form-control bookingrange"
                        type="text"
                      />
                    </DateRangePicker>
                  </div>

                  <div className="contacts-header-actions">
                    <div className="contacts-actions-left">
                      <button
                        className="btn btn-primary me-2 d-flex align-items-center contacts-refresh-btn"
                        onClick={handleRefresh}
                        disabled={isRefreshing}
                      >
                        <i
                          className={`ti ti-refresh fs-5 ${
                            isRefreshing ? "ti-spin" : ""
                          }`}
                        />
                      </button>

                      <div className="form-sorts dropdown me-2 h-100">
                        <Link
                          to="#"
                          className={
                            "d-flex justify-content-center align-items-center"
                          }
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-filter-share m-0" />
                          Filter
                        </Link>
                        <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                          <div className="filter-set-view">
                            <div className="filter-set-head">
                              <h4>
                                <i className="ti ti-filter-share" />
                                Filter
                              </h4>
                            </div>
                            <div className="accordion" id="accordionExample">
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className="collapsed"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#Status"
                                    aria-expanded="false"
                                    aria-controls="Status"
                                  >
                                    Call Status
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="Status"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <ul>
                                      {callStatus.map((callStatus, index) => {
                                        return (
                                          <li key={index}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={selectedCallStatus.includes(
                                                    callStatus.value
                                                  )}
                                                  onChange={() => {
                                                    filterCallStatus(
                                                      callStatus.value
                                                    );
                                                  }}
                                                />
                                                <span className="checkmarks" />
                                                {callStatus.label}
                                              </label>
                                            </div>
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className="collapsed"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#Direction"
                                    aria-expanded="false"
                                    aria-controls="Direction"
                                  >
                                    Call Direction
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="Direction"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <ul>
                                      {callDirection.map(
                                        (callDirection, index) => {
                                          return (
                                            <li key={index}>
                                              <div className="filter-checks">
                                                <label className="checkboxs">
                                                  <input
                                                    type="checkbox"
                                                    checked={selectedCallDirection.includes(
                                                      callDirection.value.toLowerCase()
                                                    )}
                                                    onChange={() => {
                                                      filterCallDirection(
                                                        callDirection.value.toLowerCase()
                                                      );
                                                    }}
                                                  />
                                                  <span className="checkmarks" />
                                                  {callDirection.label}
                                                </label>
                                              </div>
                                            </li>
                                          );
                                        }
                                      )}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="filter-reset-btns">
                              <div className="row">
                                <div className="col-6"></div>
                                <div className="col-6">
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    onClick={resetFilters}
                                  >
                                    Reset
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="dropdown">
                        <Link
                          to="#"
                          className="btn bg-soft-purple text-purple"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-columns-3 me-2" />
                          <span className="d-none d-sm-inline">
                            Manage Columns
                          </span>
                          <span className="d-inline d-sm-none">Columns</span>
                        </Link>
                        <div className="dropdown-menu  dropdown-menu-md-end dropdown-md p-3">
                          <h4 className="mb-2 fw-semibold">
                            Want to manage datatables?
                          </h4>
                          <p className="mb-3">
                            Please drag and drop your column to reorder your
                            table and enable see option as you want.
                          </p>
                          <div className="border-top pt-3">
                            {columns.map((column, index) => {
                              if (
                                column.title === "Action" ||
                                column.title === ""
                              ) {
                                return;
                              }
                              return (
                                <div
                                  className="d-flex align-items-center justify-content-between mb-3"
                                  key={index}
                                >
                                  <p className="mb-0 d-flex align-items-center">
                                    <i className="ti ti-grip-vertical me-2" />
                                    {column.title}
                                  </p>
                                  <div className="status-toggle">
                                    <input
                                      type="checkbox"
                                      id={column.title}
                                      className="check"
                                      defaultChecked={true}
                                      onClick={() =>
                                        handleToggleColumnVisibility(
                                          column.title
                                        )
                                      }
                                    />
                                    <label
                                      htmlFor={column.title}
                                      className="checktoggle"
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>

                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-package-export me-2" />
                          Export
                        </Link>
                        <div className="dropdown-menu dropdown-menu-end">
                          <ul className="mb-0">
                            <li>
                              <Link
                                to="#"
                                className="dropdown-item"
                                onClick={exportPDF}
                              >
                                <i className="ti ti-file-type-pdf text-danger me-1" />
                                Export as PDF
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#"
                                className="dropdown-item"
                                onClick={exportExcel}
                              >
                                <i className="ti ti-file-type-xls text-green me-1" />
                                Export as Excel{" "}
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <Row gutter={[24, 24]} className="data-cards-row mb-4">
                  <Col xs={24} sm={12} lg={6}>
                    <Card
                      className="metric-card inbound-card"
                      hoverable
                      onClick={() => {
                        setSelectedCallStatus([]);
                        setSelectedCallDirection(["inbound"]);
                      }}
                      styles={{
                        body: { padding: "24px" },
                      }}
                    >
                      <Space
                        direction="horizontal"
                        size="small"
                        style={{
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div className="metric-header">
                          <IoCall
                            size={24}
                            className="metric-icon inbound-icon"
                          />
                          <Text type="secondary" className="metric-label">
                            Inbound Calls
                          </Text>
                        </div>
                        <Statistic
                          value={callLogsSummary?.inboundCalls}
                          precision={0}
                          className="metric-value"
                          valueStyle={{
                            color: "#52c41a",
                            fontSize: "28px",
                          }}
                        />
                      </Space>
                    </Card>
                  </Col>

                  <Col xs={24} sm={12} lg={6}>
                    <Card
                      className="metric-card outbound-card"
                      hoverable
                      onClick={() => {
                        setSelectedCallStatus([]);
                        setSelectedCallDirection(["outbound"]);
                      }}
                      styles={{
                        body: { padding: "24px" },
                      }}
                    >
                      <Space
                        direction="horizontal"
                        size="small"
                        style={{
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div className="metric-header-allCalls">
                          <IoCallOutline
                            size={24}
                            className="metric-icon outbound-icon"
                          />
                          <Text type="secondary" className="metric-label">
                            Outbound Calls
                          </Text>
                        </div>
                        <Statistic
                          value={callLogsSummary?.outboundCalls}
                          precision={0}
                          className="metric-value"
                          valueStyle={{
                            color: "#1890ff",
                            fontSize: "28px",
                          }}
                        />
                      </Space>
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} lg={6}>
                    <Card
                      className="metric-card outbound-card"
                      hoverable
                      onClick={() => {
                        setSelectedCallDirection([]);
                        setSelectedCallStatus(["missedCall"]);
                      }}
                      styles={{
                        body: { padding: "24px" },
                      }}
                    >
                      <Space
                        direction="horizontal"
                        size="small"
                        style={{
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div className="metric-header-allCalls">
                          <IoCallOutline
                            size={24}
                            className="metric-icon missed-icon"
                          />
                          <Text type="secondary" className="metric-label">
                            Missed Calls
                          </Text>
                        </div>
                        <Statistic
                          value={callLogsSummary?.missedCalls}
                          precision={0}
                          className="metric-value"
                          valueStyle={{
                            color: "#ff1b1bff",
                            fontSize: "28px",
                          }}
                        />
                      </Space>
                    </Card>
                  </Col>

                  <Col xs={24} sm={12} lg={6}>
                    <Card
                      className="metric-card total-card"
                      hoverable
                      onClick={() => {
                        setSelectedCallDirection([]);
                        setSelectedCallStatus([]);
                      }}
                      styles={{
                        body: { padding: "24px" },
                      }}
                    >
                      <Space
                        direction="horizontal"
                        size="small"
                        style={{
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div className="metric-header">
                          <IoAlertCircle
                            size={24}
                            className="metric-icon total-icon"
                          />
                          <Text type="secondary" className="metric-label">
                            Total Calls
                          </Text>
                        </div>
                        <Statistic
                          value={callLogsSummary?.totalCalls}
                          precision={0}
                          className="metric-value"
                          valueStyle={{
                            color: "#722ed1",
                            fontSize: "28px",
                          }}
                        />
                      </Space>
                    </Card>
                  </Col>
                </Row> */}
          </div>

          <div className="card-body">
            <div className="table-responsive custom-table">
              <Table
                dataSource={filteredCallData}
                columns={visibleColumns}
                rowKey={(record) => record.key}
                loading={
                  callHistoryState.loading ||
                  callHistoryGlobalState.fetchAndStoreLoading
                }
                pagination={{
                  current: callHistoryState.pagination.page,
                  pageSize: callHistoryState.pagination.page_size,
                  total: callHistoryState.pagination.total,
                }}
                onPaginationChange={handlePageChange}
                showRowSelection={false}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal custom-modal fade modal-padding"
        id="play_recording"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Recording</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {}}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="px-4">
                {audioUrl && (
                  <audio
                    controls
                    id="globalAudioPlayer"
                    src={audioUrl}
                    style={{ width: "100%", marginTop: "20px" }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentCallLogsAndRecordings;
